import { NavLink } from 'react-router-dom'
import { Switch, Route } from 'react-router-dom'
import DevProjects from './pages/DevProjects/DevProjects'
import DesignProjects from './pages/DesignProjects/DesignProjects';
import Experience from './pages/Experience/Experience';
import Home from './pages/Home/Home';
import Footer from './components/Footer/Footer';
import './App.css'

function App() {
  return (
    <div className="App">
      <div className="nabvar">
        <NavLink to={"/"}  className="logo">VG.</NavLink>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label className="menu-icon" htmlFor="menu-btn"><span className="navicon"></span></label>
        <ul className="menu">
          <li><NavLink to={"/"} exact className="navbar-option" activeClassName="navbar-option-active"> About me </NavLink></li>
          <li><NavLink to={"/dev-projects"} className="navbar-option" activeClassName="navbar-option-active"> Dev projects </NavLink></li>
          <li><NavLink to={"/design-portfolio"} className="navbar-option" activeClassName="navbar-option-active"> Design portfolio</NavLink></li>
          <li><NavLink to={"/experience"} className="navbar-option" activeClassName="navbar-option-active"> Experience</NavLink></li>
        </ul>
      </div>

      <Switch>
        <Route exact path="/" component={Home}/>
        <Route path="/dev-projects" component={DevProjects}/>
        <Route path="/design-portfolio" component={DesignProjects}/>
        <Route path="/experience" component={Experience}/>
      </Switch>

      <Footer/>

    </div>
  );
}

export default App;